module.exports = __webpack_public_path__ + "img/2-24.d4649b37.jpg";